import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api/config';
import './joplist.css';

import { MdWork, MdOutlineLocationCity, MdDateRange } from "react-icons/md";
import { LuArrowRight, LuChevronRight } from "react-icons/lu";

const JobList = () => {
    const [activeTab, setActiveTab] = useState('merkez');
    const [activeSubTab, setActiveSubTab] = useState('yurt-personel');
    const [jobs, setJobs] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const navigationStructure = [
        { 
            key: 'merkez',        
            label: 'Genel Merkez',  
            endpoint: '/api/basvurular/tum/merkez',        
            path: (id) => `/merkez-ilanlar/${id}` 
        },
        { 
            key: 'yurt',          
            label: 'Yurt Hizmetleri',          
            subTabs: [
                { key: 'yurt-personel', label: 'Hizmetli Personel', endpoint: '/api/basvurular/tum/yurt-personel', path: (id) => `/yurt-personel-ilanlar/${id}` },
                { key: 'yurt-yonetici', label: 'İdari Personel', endpoint: '/api/basvurular/tum/yurt-yonetici', path: (id) => `/yurt-yonetici-ilanlar/${id}` }
            ]
        },
        { 
            key: 'neva-yemek',    
            label: 'Yemek Hizmetleri',    
            endpoint: '/api/basvurular/tum/neva-yemek',    
            path: (id) => `/neva-yemek-ilanlar/${id}` 
        },
    ];

    const getActiveConfig = () => {
        const mainTab = navigationStructure.find(t => t.key === activeTab);
        if (mainTab?.subTabs) {
            return mainTab.subTabs.find(st => st.key === activeSubTab) || mainTab.subTabs[0];
        }
        return mainTab;
    };

    const activeConfig = getActiveConfig();

    const fetchJobs = async () => {
        if (!activeConfig?.endpoint) return;
        setLoading(true);
        try {
            const response = await api.get(activeConfig.endpoint);
            setJobs(response.data.ilanlar || []);
        } catch (error) {
            console.error('Kariyer fırsatları yüklenirken hata oluştu:', error);
            setJobs([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchJobs();
    }, [activeTab, activeSubTab]);

    const handleNavigation = (jobId) => {
        if (activeConfig) {
            navigate(activeConfig.path(jobId));
        }
    };

    const renderMainTabs = () => (
        <div className="corporate-tab-wrapper">
            <div className="corporate-tab-container">
                {navigationStructure.map(tab => (
                    <button
                        key={tab.key}
                        onClick={() => {
                            setActiveTab(tab.key);
                            if (tab.subTabs) setActiveSubTab(tab.subTabs[0].key);
                        }}
                        className={`corporate-tab-item ${activeTab === tab.key ? 'is-active' : ''}`}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>
            {/* Mobil kullanıcılar için sağa kaydırma ipucu simgesi */}
            <div className="corporate-scroll-indicator" aria-hidden="true">
                <LuChevronRight />
            </div>
        </div>
    );

    const renderSubTabs = () => {
        const mainTab = navigationStructure.find(t => t.key === 'yurt');
        if (activeTab !== 'yurt' || !mainTab?.subTabs) return null;

        return (
            <div className="corporate-subtab-wrapper">
                <div className="corporate-subtab-container">
                    {mainTab.subTabs.map(subTab => (
                        <button
                            key={subTab.key}
                            onClick={() => setActiveSubTab(subTab.key)}
                            className={`corporate-subtab-item ${activeSubTab === subTab.key ? 'is-active' : ''}`}
                        >
                            {subTab.label}
                        </button>
                    ))}
                </div>
            </div>
        );
    };

    return (
        <div className="corporate-career-container">
            {renderMainTabs()}
            {renderSubTabs()}

            <div className="corporate-job-grid">
                {loading ? (
                    <div className="corporate-state-message">
                        <span className="loader-dots">Açık pozisyonlar listeleniyor...</span>
                    </div>
                ) : jobs.length > 0 ? (
                    jobs.map((job) => {
                        const detail = job.ilan_detay || {};
                        return (
                            <div key={detail.id || Math.random()} className="corporate-job-card">
                                <div className="job-card-main-content">
                                    <h3 className="job-card-title">
                                        {detail.ilan_basligi || 'Genel Başvuru'}
                                    </h3>
                                    
                                    <div className="job-card-metadata">
                                        <div className="meta-item">
                                            <MdWork className="meta-icon" />
                                            <span>{detail.is_tipi || 'Tam Zamanlı'}</span>
                                        </div>
                                        <div className="meta-item">
                                            <MdOutlineLocationCity className="meta-icon" />
                                            <span>{detail.sehir || 'Merkez'}</span>
                                        </div>
                                        <div className="meta-item">
                                            <MdDateRange className="meta-icon" />
                                            <span>Son Başvuru: {detail.ilan_tarihi ? new Date(detail.ilan_tarihi).toLocaleDateString('tr-TR') : '-'}</span>
                                        </div>
                                    </div>
                                </div>
                                
                                <button 
                                    onClick={() => handleNavigation(detail.id)} 
                                    className="corporate-primary-button"
                                    aria-label={`${detail.ilan_basligi || 'Pozisyona'} başvur`}
                                >
                                    <span>Pozisyonu İncele</span>
                                    <LuArrowRight className="button-arrow" />
                                </button>
                            </div>
                        );
                    })
                ) : (
                    <div className="corporate-state-message empty-state">
                        Şu an için bu kategoride açık pozisyon bulunmamaktadır.
                    </div>
                )}
            </div>
        </div>
    );
};

export default JobList;